import React from 'react';

function Success() {
  // eslint-disable-next-line no-unused-vars

  const title = 'We’ve received your enquiry';

  return (
    <div className="ds-container-alerts-sign-up">
      <div className="ds-grid ds-col-1">
        <div className="ds-col-1">
          <h2>{title}</h2>
        </div>

        <div className="ds-col-1">
          <h3>What happens next</h3>
          <p>Thank you for contacting Midlands Connect.</p>
          <p>We will acknowledge your query and keep you updated on progress.</p>
        </div>
      </div>
    </div>
  );
}

export default Success;
